export const AUTH_REQUIRED_EVENT = 'sololine:auth-required';
export const AUTH_EVENT_SOURCE = 'editor-frontend';
